import * as React from 'react';
import RevokeBadgeForm from './RevokeBadgeForm';

const RevokeBadge = () => {
    return <RevokeBadgeForm />;
}

export default RevokeBadge;
